<template>
  <!--*组件名称
      * @module '@/components/CargoInfo/CargoInfo'
      * @desc 货物信息与货物小计组件
      * @author lwc
      * @date  2021年3月17日
      * @param {} []    - 参数说明
      * @param {} [] - 参数说明
      * @example 调用示例
          * @getCargoInfo="getCargoInfo"：子向父传值，父取值；
          * :cargoInfoForm="cargoInfoForm"：父向子传值，子组件中用props接收
          * <carogo-info @getCargoInfo="getCargoInfo" :cargoInfoForm="cargoInfoForm"/>
  -->
  <div class="cargoInfo-contanier">
    <el-form
      :disabled="isApprovalStatus ||
        ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'
      "
      ref="cargoStatisticsFormRef"
      :rules="cargoStatisticsFormRules"
      :model="ebCargo.ebCargoM"
      class="form-panel marg10"
      label-position="top"
    >
      <el-col class="panel-top goodsSubtotal">
       <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col >
                  <span class="title-text">货物小计</span>
                </el-col>
                </div>
              </el-row>
      <el-row class="t-panel">
        <el-row class="content-panel-t">
          <el-col>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="唛头:" prop="marks">
                  <el-input
                    size="mini"
                    type="textarea"
                    :rows="7"
                    case="upper"
                    @change="getCargoInfoToParents"
                    v-model="ebCargo.ebCargoM.marks"
                    :title="ebCargo.ebCargoM.marks"
                    ref="marks"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="货物描述:" prop="cargoDescription">
                  <el-input
                    size="mini"
                    type="textarea"
                    case="upper"
                    @change="getCargoInfoToParents"
                    :rows="7"
                    v-model="ebCargo.ebCargoM.cargoDescription"
                    :title="ebCargo.ebCargoM.cargoDescription"
                    ref="cargoDescription"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-row>
                  <el-col>
                    <el-row :gutter="10">
                      <el-col :span="9">
                        <el-row :gutter="5">
                          <el-col :span="9">
                            <el-form-item label="件数:" prop="noOfPackage">
                              <el-input
                                @focus="getInputFocus($event)"
                                size="mini"
                                v-model="ebCargo.ebCargoM.noOfPackage"
                                :title="ebCargo.ebCargoM.noOfPackage"
                                onkeyup="value=value.replace(/[^\d.]/g,'')"
                                @change="getCargoInfoToParents"
                                :disabled="btnVisible"
                                ref="noOfPackage"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="15">
                            <el-form-item
                              label="包装单位:"
                              prop="packageTypeName"
                            >
                              <el-associate
                                style="width: 100%"
                                :columns="associate_columns_packageType"
                                :query-method="
                                  associate_queryMethod_packageType
                                "
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="enName"
                                value-prop="mdChargeunitCode"
                                placeholder=""
                                :disabled="btnVisible"
                                v-model="ebCargo.ebCargoM.packageTypeName"
                                :title="ebCargo.ebCargoM.packageTypeName"
                                size="mini"
                                @change="onChangeebCargoMPackageType"
                                case="upper"
                                ref="packageTypeName"
                              />
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="5">
                        <el-form-item label="毛重(KGS):" prop="grossWeight">
                          <el-input
                            @focus="getInputFocus($event)"
                            size="mini"
                            @change="getCargoInfoToParents"
                            onkeyup="value=value.replace(/[^\d.]/g, '')"
                            v-model="ebCargo.ebCargoM.grossWeight"
                            :title="ebCargo.ebCargoM.grossWeight"
                            :disabled="btnVisible"
                            ref="grossWeight"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-form-item label="体积(CBM):" prop="cube">
                          <el-input
                            @focus="getInputFocus($event)"
                            size="mini"
                            onkeyup="value=value.replace(/[^\d.]/g,'')"
                            @change="getCargoInfoToParents"
                            v-model="ebCargo.ebCargoM.cube"
                            :title="ebCargo.ebCargoM.cube"
                            :disabled="btnVisible"
                            ref="cube"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-form-item label="净重(KGS):">
                          <el-input
                            size="mini"
                            @change="getCargoInfoToParents"
                            onkeyup="value=value.replace(/[^\d.]/g,'')"
                            v-model="ebCargo.ebCargoM.netWeight"
                            :title="ebCargo.ebCargoM.netWeight"
                            :disabled="btnVisible"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="10">
                      <el-col :span="9">
                        <el-form-item label="HS CODE:" prop="hsCode">
                          <el-input
                            size="mini"
                            case="upper"
                            @change="getCargoInfoToParents"
                            v-model="ebCargo.ebCargoM.hsCode"
                            :title="ebCargo.ebCargoM.hsCode"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="15">
                        <el-form-item label="中文品名:" prop="cargoName">
                          <el-input
                              size="mini"
                              case="upper"
                              @change="getCargoInfoToParents"
                              v-model="ebCargo.ebCargoM.cargoName"
                              :title="ebCargo.ebCargoM.cargoName"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-checkbox
                      v-model="ebCargo.ebCargoM.isHazard"
                      :true-label="1"
                      :false-label="0"
                      :disabled="btnVisible"
                      @change="getCargoInfoToParents('W')"
                    >危险品
                    </el-checkbox>
                    <el-checkbox
                      v-model="ebCargo.ebCargoM.isReefer"
                      :true-label="1"
                      :false-label="0"
                      :disabled="btnVisible"
                      @change="getCargoInfoToParents('L')"
                    >冷藏品
                    </el-checkbox>
                    <el-checkbox
                      v-model="ebCargo.ebCargoM.isBulkyCargo"
                      :true-label="1"
                      :false-label="0"
                      :disabled="btnVisible"
                      @change="getCargoInfoToParents('B')"
                    >大件货
                    </el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- 危险品 -->
        <el-row class="cargo-type" v-if="dangerVisible">
             <el-row class="title-panel-external no-padding">
                <div class="title-panel cargo-type-title-panel">
                  <el-col>
                  <span class="title-text">危险品</span>
                </el-col>
                </div>
              </el-row>
             <el-col class="top-inline">
            <el-row class="content-cargo-type position-parent" :gutter="10">
              <el-row :gutter="40">
                <el-col :span="6">
                  <el-form-item label="危险品编码:" prop="unNo" key="unNo">
                    <el-input
                      size="mini"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.unNo"
                      ref="unNo"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="危险品种类:"
                    prop="hazardClass"
                    key="hazardClass"
                  >
                    <el-select
                      class="length_input"
                      size="mini"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.hazardClass"
                      placeholder="请选择"
                      ref="hazardClass"
                    >
                      <el-option
                        v-for="item in hazardClassList"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-row>
                    <el-col :span="14">
                      <el-form-item label="闪点/单位:" prop="flashPoint">
                        <el-input
                          size="mini"
                          @change="getCargoInfoToParents"
                          v-model="ebCargo.ebCargoM.flashPoint"
                          :title="ebCargo.ebCargoM.flashPoint"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="" prop="">
                        <label slot="label" class="label_no"></label>
                        <el-select
                          class="length_input"
                          size="mini"
                          @change="getCargoInfoToParents"
                          v-model="ebCargo.ebCargoM.flashPointUnit"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in flashPointUnitList"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="危险品净重:" prop="netWeight">
                    <el-input
                      size="mini"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.netWeight"
                      :title="ebCargo.ebCargoM.netWeight"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40">
                <el-col :span="6">
                  <el-form-item
                    label="紧急联系人:"
                    prop="urgentContract"
                    key="urgentContract"
                  >
                    <el-input
                      size="mini"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.urgentContract"
                      :title="ebCargo.ebCargoM.urgentContract"
                      ref="urgentContract"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="紧急联系电话:"
                    prop="urgentContractTel"
                    key="urgentContractTel"
                  >
                    <el-input
                      size="mini"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.urgentContractTel"
                      :title="ebCargo.ebCargoM.urgentContractTel"
                      ref="urgentContractTel"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="紧急联系人公司抬头:" prop="urgentContractCompany">
                    <el-input
                      size="mini"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.urgentContractCompany"
                      :title="ebCargo.ebCargoM.urgentContractCompany"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="技术品名:" prop="dangerTechnicalDesc">
                    <el-input
                      size="mini"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.dangerTechnicalDesc"
                      :title="ebCargo.ebCargoM.dangerTechnicalDesc"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40">
                <el-col :span="6">
                  <el-row>
                    <el-col :span="14">
                      <el-form-item label="内包装单位/件数:" prop="packageTypeName">
                        <!-- <el-input size="mini" @change="getCargoInfoToParents"
                                          v-model="ebCargo.ebCargoM.innerPackageTypeCode"></el-input> -->
                        <el-associate
                          style="width: 100%"
                          :columns="associate_columns_packageType"
                          :query-method="associate_queryMethod_packageType"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="enName"
                          value-prop="mdChargeunitCode"
                          placeholder=""
                          :disabled="btnVisible"
                          v-model="ebCargo.ebCargoM.packageTypeName"
                          :title="ebCargo.ebCargoM.packageTypeName"
                          size="mini"
                          @change="onChangePackageType"
                          case="upper"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item label="" prop="">
                        <label slot="label" class="label_no"></label>
                        <el-input
                          size="mini"
                          @change="getCargoInfoToParents"
                          onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                          v-model="ebCargo.ebCargoM.noOfPackage"
                          :title="ebCargo.ebCargoM.noOfPackage"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="仓库抬头:" prop="warehouseName">
                    <el-input
                      size="mini"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.warehouseName"
                      :title="ebCargo.ebCargoM.warehouseName"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="仓库地址:" prop="warehouseAddress">
                    <el-input
                      size="mini"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.warehouseAddress"
                      :title="ebCargo.ebCargoM.warehouseAddress"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="仓库联系电话:" prop="warehouseContactTel">
                    <el-input
                      size="mini"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.warehouseContactTel"
                      :title="ebCargo.ebCargoM.warehouseContactTel"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40">
              <el-col :span="6">
                <el-form-item label="仓库传真:" prop="warehouseContactFax">
                  <el-input
                    size="mini"
                    @change="getCargoInfoToParents"
                    v-model="ebCargo.ebCargoM.warehouseContactFax"
                    :title="ebCargo.ebCargoM.warehouseContactFax"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="仓库联系人:" prop="warehouseContact">
                  <el-input
                    size="mini"
                    @change="getCargoInfoToParents"
                    v-model="ebCargo.ebCargoM.warehouseContact"
                    :title="ebCargo.ebCargoM.warehouseContact"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="" prop="">
                  <label slot="label" class="label_no"></label>
                  <el-checkbox
                    v-model="ebCargo.ebCargoM.isOceanPollution"
                    :true-label="1"
                    :false-label="0"
                    @change="getCargoInfoToParents"
                  >海洋污染物
                  </el-checkbox>
                  <el-checkbox
                    v-model="ebCargo.ebCargoM.isDeclare"
                    :true-label="1"
                    :false-label="0"
                    @change="getCargoInfoToParents"
                  >危险品申报
                  </el-checkbox>
                </el-form-item>
              </el-col>
              </el-row>
            </el-row>
             </el-col>
        </el-row>
        <!-- 冷藏品 -->
        <el-row class="cargo-type" v-if="frezzVisible">
             <el-row class="title-panel-external no-padding">
                <div class="title-panel cargo-type-title-panel">
                  <el-col>
                  <span class="title-text">冷藏品</span>
                </el-col>
                </div>
              </el-row>
            <el-row class="content-cargo-type top-inline" :gutter="10">
              <el-row :gutter="40">
                <el-col :span="6">
                  <el-form-item
                    label="设置温度:"
                    prop="temperature"
                    key="temperature"
                  >
                    <el-input
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      onkeyup="value=value.replace(/[^\-?\d.]/g, '')"
                      v-model="ebCargo.ebCargoM.temperature"
                      :title="ebCargo.ebCargoM.temperature"
                      ref="temperature"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="温度计量单位:"
                    prop="temperatureUnit"
                    key="temperatureUnit"
                  >
                    <el-select
                      class="length_input"
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.temperatureUnit"
                      placeholder="请选择"
                      ref="temperatureUnit"
                    >
                      <el-option
                        v-for="item in flashPointUnitList"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="冷藏通风量:"
                    prop="airVentsSet"
                    key="airVentsSet"
                  >
                    <el-input
                      placeholder="0:关闭通风;100:通风全开"
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      onkeyup="value=value.replace(/[^\-?\d.]/g, '')"
                      v-model="ebCargo.ebCargoM.airVentsSet"
                      :title="ebCargo.ebCargoM.airVentsSet"
                      ref="airVentsSet"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="通风单位:" prop="">
                    <el-select
                      class="length_input"
                      size="mini"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.airVentsUnit"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in airVentsUnitList"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40">
                <el-col :span="6">
                  <el-form-item label="湿度:" prop="">
                    <el-input
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      onkeyup="value=value.replace(/[^\-?\d.]/g, '')"
                      v-model="ebCargo.ebCargoM.Humidity"
                      :title="ebCargo.ebCargoM.Humidity"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="冷藏品最低温度:" prop="temperatureMin">
                    <el-input
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      onkeyup="value=value.replace(/[^\-?\d.]/g, '')"
                      v-model="ebCargo.ebCargoM.temperatureMin"
                      :title="ebCargo.ebCargoM.temperatureMin"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="冷藏品最高温度:" prop="temperatureMax">
                    <el-input
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      onkeyup="value=value.replace(/[^\-?\d.]/g, '')"
                      v-model="ebCargo.ebCargoM.temperatureMax"
                      :title="ebCargo.ebCargoM.temperatureMax"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
        </el-row>
        <!-- 大件货 -->
        <el-row
          class="cargo-type big"
          v-if="bigVisible"
        >
            <el-row class="title-panel-external no-padding">
                <div class="title-panel cargo-type-title-panel">
                  <el-col>
                  <span class="title-text">大件货</span>
                </el-col>
                </div>
              </el-row>
            <el-row class="content-cargo-type position-parent top-inline" :gutter="10">
              <el-row :gutter="40">
                <el-col :span="6">
                  <el-form-item label="长度(CM):" prop="length" key="length">
                    <el-input-number
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      :controls="false"
                      precision="2"
                      style="width: 100%"
                      v-model="ebCargo.ebCargoM.length"
                      :title="ebCargo.ebCargoM.length"
                      ref="length"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="宽度(CM):" prop="width" key="width">
                    <el-input-number
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      :controls="false"
                      precision="2"
                      style="width: 100%"
                      v-model="ebCargo.ebCargoM.width"
                      :title="ebCargo.ebCargoM.width"
                      ref="width"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="高度(CM):" prop="height" key="height">
                    <el-input-number
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      :controls="false"
                      precision="2"
                      style="width: 100%"
                      v-model="ebCargo.ebCargoM.height"
                      :title="ebCargo.ebCargoM.height"
                      ref="height"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="超重(KG):" prop="overWeight">
                    <el-input-number
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      :controls="false"
                      precision="2"
                      style="width: 100%"
                      v-model="ebCargo.ebCargoM.overWeight"
                      :title="ebCargo.ebCargoM.overWeight"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40">
                <el-col :span="6">
                  <el-form-item label="超高(CM):" prop="overHigh">
                    <el-input-number
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      :controls="false"
                      precision="2"
                      style="width: 100%"
                      v-model="ebCargo.ebCargoM.overHigh"
                      :title="ebCargo.ebCargoM.overHigh"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="前超(CM):" prop="overFront">
                    <el-input-number
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      :controls="false"
                      precision="2"
                      style="width: 100%"
                      v-model="ebCargo.ebCargoM.overFront"
                      :title="ebCargo.ebCargoM.overFront"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="后超(CM):" prop="overBehind">
                    <el-input-number
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      :controls="false"
                      precision="2"
                      style="width: 100%"
                      v-model="ebCargo.ebCargoM.overBehind"
                      :title="ebCargo.ebCargoM.overBehind"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="左超(CM):" prop="overLeft">
                    <el-input-number
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      :controls="false"
                      precision="2"
                      style="width: 100%"
                      v-model="ebCargo.ebCargoM.overLeft"
                      :title="ebCargo.ebCargoM.overLeft"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="40">
                <el-col :span="6">
                  <el-form-item label="右超(CM):" prop="overRight">
                    <el-input-number
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      :controls="false"
                      precision="2"
                      style="width: 100%"
                      v-model="ebCargo.ebCargoM.overRight"
                      :title="ebCargo.ebCargoM.overRight"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="大件货备注:" prop="bulkyCargoRemark">
                    <el-input
                      size="mini"
                      case="upper"
                      @change="getCargoInfoToParents"
                      v-model="ebCargo.ebCargoM.bulkyCargoRemark"
                      :title="ebCargo.ebCargoM.bulkyCargoRemark"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
        </el-row>
       </el-row>
      </el-col>
    </el-form>
    <el-form
      :disabled="isApprovalStatus ||
        ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'
      "
      ref="cargoInfoFormRef"
      :rules="cargoInfoFormRules"
       class="form-panel form-panel-cargo"
      v-if="isShowCargoInfoForm"
      label-position="top"
      :model="ebCargo"
    >
      <div class="panel-top panel-top-cargo handsontable-set">
        <el-row class="enlarged-title-panel enlarged-title-panel-cargo  handsontable-set">
          <el-row class="enlarged-title">
              <div class="enlarged-title-text cargo-info-title">
                <span class="title-text">货物信息</span>
             </div>
            <div class="enlarged-title-buttons enlarged-title-buttons-cargo">
                  <div class="add-button">
                    <el-button icon="el-icon-circle-plus-outline" type="primary" size="mini" @click="addNewRow()"
                    >新增</el-button
                    >
                  </div>
                 <div>
                    <el-button type="danger" size="mini" @click="batchDelete()"
                    >删除</el-button
                    >
                </div>
            </div>
          </el-row>
        </el-row>
           <el-row class="content-panel content-panel-cargo  handsontable-set">
              <hot-table
                ref="ebCargoDRef"
                :data-source="ebCargo.ebCargoD"
                :settings="ebCargoDSettings"
                col-settings-key="ebCargo"
                @cellClick="ebCargoDCellClick"
                @rowDblclick="ebCargoDRowClick"
                @valueChange="valueChangeEbCargoD"
                :after-change="afterChangeEbCargoD"
                :rules="ebCargoDRules"
                key="ebCargokey"
              >
                <hot-column
                  :has-tip="true"
                  data="cargoDescription"
                  title="货物描述"
                  width="150"
                >
                  <el-input-editor hot-editor name="cargoName" case="upper" />
                </hot-column>
                <hot-column
                  :has-tip="true"
                  data="noOfPackage"
                  title="<label style='color:red'>*</label>件数"
                  width="150"
                >
                  <el-input-number-editor
                    :precision="0"
                    hot-editor
                    :controls="false"
                    name="noOfPackage"
                  />
                </hot-column>
                <hot-column
                  :has-tip="true"
                  data="packageTypeName"
                  title="<label style='color:red'>*</label>包装单位"
                  width="150"
                >
                  <el-associate-editor
                    hot-editor
                    style="width: 100%"
                    :columns="associate_columns_packageType"
                    :query-method="associate_queryMethod_packageType"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="enName"
                    value-prop="enName"
                    placeholder=""
                    name="packageTypeName"
                    size="small"
                    @focus="getMdCargoDIndex(ebCargoDIndex)"
                    @change="onChangePackageType"
                    case="upper"
                  />
                </hot-column>
                <hot-column
                  :has-tip="true"
                  data="grossWeight"
                  title="<label style='color:red'>*</label>毛重"
                  width="100"
                >
                  <el-input-number-editor
                    hot-editor
                    :controls="false"
                    :precision="0"
                    name="grossWeight"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"
                  />
                </hot-column>
                <hot-column
                  :has-tip="true"
                  data="netWeight"
                  title="净重"
                  width="150"
                  type="numeric"
                  :numericFormat="{
                    pattern: '0,0.000',
                    culture: 'zh-CN',
                  }"
                >
                  <el-input-number-editor
                    hot-editor
                    :controls="false"
                    :precision="0"
                    :min="0"
                    name="netWeight"
                    case="upper"
                  />
                </hot-column>
                <hot-column
                  :has-tip="true"
                  data="cube"
                  title="<label style='color:red'>*</label>体积"
                  width="150"
                >
                  <el-input-number-editor
                    :precision="0"
                    hot-editor
                    :controls="false"
                    name="cube"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"
                  />
                </hot-column>
                <hot-column
                  :has-tip="true"
                  data="isBulkyCargo"
                  title="大件货"
                  width="150"
                  type="checkbox"
                  className="htCenter"
                  :checked-template="1"
                  :unchecked-template="0"
                  checked-display="是"
                  unchecked-display="否"
                >
                </hot-column>
                <hot-column
                  :has-tip="true"
                  data="isReefer"
                  title="冷藏品"
                  width="150"
                  type="checkbox"
                  className="htCenter"
                  :checked-template="1"
                  :unchecked-template="0"
                  checked-display="是"
                  unchecked-display="否"
                >
                </hot-column>
                <hot-column
                  :has-tip="true"
                  data="isHazard"
                  title="危险品"
                  width="150"
                  type="checkbox"
                  className="htCenter"
                  :checked-template="1"
                  :unchecked-template="0"
                  checked-display="是"
                  unchecked-display="否"
                >
                </hot-column>
                <hot-column
                  :has-tip="true"
                  data="cargoName"
                  title="中文品名"
                  width="150"
                >
                  <el-input-editor hot-editor name="cargoName" case="upper" />
                </hot-column>
              </hot-table>
           </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import { queryCarrierInfo, queryPackageInfo } from "@/api/commonService";
import {
  cargoInfoFormRules,
  cargoStatisticsFormRules,
} from "@/rules/booking_rules";
import { ebCargoDValidate } from "@/rules/rules";
import { queryDictRows } from "@/api/commonService";
import { deleteEbCargo } from "@/api/bookingRequest";
import { getBookingVO } from "@/api/bookingRequest";
import autoFocusMixin from "@/mixin/autoFocus";

export default {
  name: "CargoInfo",
    mixins: [autoFocusMixin],
  // 接收父组件的值
  props: {
    isShowCargoInfoForm: {
      type: Boolean,
      default: true,
    },
    ebOrder: {
      type: Object,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return {}
      }
    },
    ebBlPlan: {},
    ebCargo: {
      ebCargoD: {
        type: Array,
        default: [],
      },
      ebCargoM: {
        marks: "",
        cargoName: "",
        noOfPackage: "",
        packageTypeName: "",
        grossWeight: "",
        netWeight: "",
        cube: "",
        isBulkyCargo: 0,
        isReefer: 0,
        isHazard: 0,
        hazardClass: "",
        flashPointUnit: "C",
      },
    },
  },
  data() {
    return {
      isApprovalStatus: false,
      ebCargoDIndex: null, //当前选中的货物信息
      dangerVisible: false,
      frezzVisible: false,
      bigVisible: false,
      list: [],
      //mdCargoD标记
      mdCargoDIndex: 0,
      //包装联想控件
      associate_columns_packageType: [
        {
          title: "中文名称",
          field: "cnName",
        },
        {
          title: "英文名称",
          field: "enName",
        },
        {
          title: "代码",
          field: "mdChargeunitCode",
        },
      ],
      cargoInfoFormRules: {
        ...cargoInfoFormRules,
      },
      cargoStatisticsFormRules: {
        ...cargoStatisticsFormRules,
      },
      cargoStatisticsForm: {
        checkList: [],
        shippingMark: "",
        cargoDetail: "",
        zh_name: "",
        en_name: "",
        pieces: "",
        grossWeight: "", //毛重
        volume: "", //体积
      },
      btnVisible: false,
      ebCargoDRules: {},
      ebCargoDSettings: {
        height: 130,
        autoColumnSize: true,
        stretchH: "none", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        columnSorting: true,
        rowHeaders: true,
        showSelection: true,
        dragCheck: true,
        rowHeights: 26, // 行高
        manualColumnResize: true,
        manualColumnMove: false, // 禁止拖动
        autoWrapRow: true, // 允许换行
        licenseKey: "non-commercial-and-evaluation",
        filters: true,
        dropdownMenu: ["filter_by_value", "filter_action_bar"],
      },
      // 危险种类
      hazardClassList: [],
      // 单位
      flashPointUnitList: [],
      // 通风单位
      airVentsUnitList: [],
    };
  },
  computed: {
    computedEbCargoM() {
      return JSON.stringify(this.ebCargo.ebCargoM);
    },
    computedEbOrder() {
      return JSON.stringify(this.ebOrder);
    },
  },
  watch: {
    'ebBlPlan.approvalStatus': {
      deep: true,
      handler(){
        if(this.ebBlPlan.approvalStatus === 'SUB' || this.ebBlPlan.approvalStatus === 'CRM') {
          this.isApprovalStatus = true
        } else if(this.ebBlPlan.approvalStatus === 'NEW') {
          this.isApprovalStatus = false
        }
      }
    },
    computedEbCargoM: {
      handler(newValue, oldValue) {
        let newEbCargoM = JSON.parse(newValue);
        if (newEbCargoM.rowStatus === 2) {
          this.ebCargo.ebCargoM.rowStatus = 16;
        }
        console.log(newEbCargoM)
        if (newEbCargoM.isBulkyCargo === 1) this.bigVisible = true;
        if (newEbCargoM.isReefer === 1) this.frezzVisible = true;
        if (newEbCargoM.isHazard === 1) this.dangerVisible = true;
      },
    },
    computedEbOrder: {
      handler(newValue, oldValue) {
        let newEbOrder = JSON.parse(newValue);
        // this.ebOrder = newEbOrder;
        this.$emit("update:ebOrder", newEbOrder);
        this.$forceUpdate();
      },
    },
  },
  async created() {

  },
  mounted() {
    this.getSelectList();
    console.log("ebCargoInfo.ebOrder:", this.ebOrder);
    console.log(this.ebBlPlan);
    this.ebCargoDRules = ebCargoDValidate();
  },
  methods: {
    getInputFocus(event){
      event.currentTarget.select();
    },
    validateAutoFocus() {
      this.autoFocus(this.ebCargo.ebCargoM, this.cargoInfoFormRules);
    },
    //获取数据字典
    getSelectList() {
      let self = this;
      queryDictRows(
        "MD_CODE_DICT$MD_CODE_HAZARD_CLASS,MD_CODE_DICT$TEMP_TYPE,MD_CODE_DICT$VENTILATION_UNIT"
      ).then((res) => {
        /*name:value value:key*/
        console.log("queryDictRows:", res);
        //危险种类
        self.hazardClassList = res.MD_CODE_DICT$MD_CODE_HAZARD_CLASS;
        self.flashPointUnitList = res.MD_CODE_DICT$TEMP_TYPE;
        self.airVentsUnitList = res.MD_CODE_DICT$VENTILATION_UNIT;
      });
    },
    //包装联想控件数据源
    associate_queryMethod_packageType({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
          isActive4: "1",
          isPackageType5: "1",
        };
      } else {
        params = {
          mdChargeunitCode0: "%" + keyword + "%",
          enName1: "%" + keyword + "%",
          cnName2: "%" + keyword + "%",
          isDeleted3: "0",
          isActive4: "1",
          isPackageType5: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdChargeunit.cnName"],
        mainModelName: "CTS_ILPMdChargeunit",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdChargeunit.mdChargeunitCode LIKE :mdChargeunitCode0 OR CTS_ILPMdChargeunit.enName LIKE :enName1) OR CTS_ILPMdChargeunit.cnName LIKE :cnName2) AND CTS_ILPMdChargeunit.isDeleted = :isDeleted3) AND CTS_ILPMdChargeunit.isActive = :isActive4) AND CTS_ILPMdChargeunit.isPackageType = :isPackageType5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdChargeunit.mdChargeunitId",
          "CTS_ILPMdChargeunit.creatorName",
          "CTS_ILPMdChargeunit.isDeleted",
          "CTS_ILPMdChargeunit.lastModifyOfficeName",
          "CTS_ILPMdChargeunit.isChargeUnit",
          "CTS_ILPMdChargeunit.lastModifyTime",
          "CTS_ILPMdChargeunit.isContainerSize",
          "CTS_ILPMdChargeunit.creatorId",
          "CTS_ILPMdChargeunit.createOffice",
          "CTS_ILPMdChargeunit.lastModifyOffice",
          "CTS_ILPMdChargeunit.deptOfficeName",
          "CTS_ILPMdChargeunit.isPackageUnit",
          "CTS_ILPMdChargeunit.enName",
          "CTS_ILPMdChargeunit.isActive",
          "CTS_ILPMdChargeunit.recordVersion",
          "CTS_ILPMdChargeunit.relateCode",
          "CTS_ILPMdChargeunit.principalGroupCode",
          "CTS_ILPMdChargeunit.settleOfficeName",
          "CTS_ILPMdChargeunit.deptOffice",
          "CTS_ILPMdChargeunit.isPackageType",
          "CTS_ILPMdChargeunit.lastModifierId",
          "CTS_ILPMdChargeunit.cnName",
          "CTS_ILPMdChargeunit.ebMdChargeunitId",
          "CTS_ILPMdChargeunit.isWeightUnit",
          "CTS_ILPMdChargeunit.createOfficeName",
          "CTS_ILPMdChargeunit.createTime",
          "CTS_ILPMdChargeunit.isCubeUnit",
          "CTS_ILPMdChargeunit.settleOffice",
          "CTS_ILPMdChargeunit.mdChargeunitCode",
          "CTS_ILPMdChargeunit.lastModifierName",
          "CTS_ILPMdChargeunit.isAreaUnit",
          "CTS_ILPMdChargeunit.remark",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPackageInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    onChangeebCargoMPackageType(value, selectedRows) {
      let self = this;
      self.ebCargo.ebCargoM.packageTypeName = selectedRows.enName;
      self.ebCargo.ebCargoM.packageTypeCode = self.ebCargo.ebCargoD[
        self.mdCargoDIndex
        ].packageTypeCode = selectedRows.mdChargeunitCode;
      self.ebCargo.ebCargoD[self.mdCargoDIndex].cnName = selectedRows.cnName;
      self.ebCargo.ebCargoD[self.mdCargoDIndex].packageTypeName =
        selectedRows.enName;
      self.$emit("getCargoInfo", this.ebCargo);
    },
    //包装联想控件修改事件
    onChangePackageType(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      let self = this;
      self.ebCargo.ebCargoD[self.mdCargoDIndex].packageTypeCode = selectedRows.mdChargeunitCode;
      self.ebCargo.ebCargoD[self.mdCargoDIndex].cnName = selectedRows.cnName;
      self.ebCargo.ebCargoD[self.mdCargoDIndex].packageTypeName = selectedRows.enName;
      self.$emit("getCargoInfo", this.ebCargo);
    },
    //内包装联想控件修改事件
    onChangeInnerPackageType(value, selectedRows) {
      console.log(selectedRows);
      let self = this;
      self.ebCargo.ebCargoD.PackageTypeCode = selectedRows.mdChargeunitCode;
      self.$emit("getCargoInfo", this.ebCargo);
    },
    //获取mdCargoD的index
    getMdCargoDIndex(index) {
      console.log("mdCargoDIndex:", index);
      this.mdCargoDIndex = index;
    },
    //触发表单校验
    ebCargoValidate: function (callback) {
      let self = this;
      let validM = true;
      self.$refs.cargoStatisticsFormRef.validate(async (validD) => {
        validM = validD;
        if(!validM) {
          if (callback) callback(validM);
          return
        }
        self.$refs.ebCargoDRef.hotInstance.validateColumns(
          [1, 2, 3, 4, 5, 6, 7],
          async (valid) => {
            validM = valid;
            if (callback) callback(validM);
          }
        );
      });
    },
    getCargoInfoToParents(type) {
      let self = this;
      if (type === "W"){
        if (self.ebCargo.ebCargoM.isHazard === 0){
          self.ebCargo.ebCargoM.unNo = null;
          self.ebCargo.ebCargoM.hazardClass = null;
          self.ebCargo.ebCargoM.flashPoint = null;
          self.ebCargo.ebCargoM.flashPointUnit = null;
          self.ebCargo.ebCargoM.netWeight = null;
          self.ebCargo.ebCargoM.urgentContract = null;
          self.ebCargo.ebCargoM.urgentContractTel = null;
          self.ebCargo.ebCargoM.urgentContractCompany = null;
          self.ebCargo.ebCargoM.dangerTechnicalDesc = null;
          self.ebCargo.ebCargoM.warehouseName = null;
          self.ebCargo.ebCargoM.warehouseAddress = null;
          self.ebCargo.ebCargoM.warehouseContactTel = null;
          self.ebCargo.ebCargoM.warehouseContactFax = null;
          self.ebCargo.ebCargoM.warehouseContact = null;
          self.ebCargo.ebCargoM.isOceanPollution = 0;
          self.ebCargo.ebCargoM.isDeclare = 0;
        }
      }else if (type === "L"){
        if (self.ebCargo.ebCargoM.isReefer === 0){
          self.ebCargo.ebCargoM.temperature = null;
          self.ebCargo.ebCargoM.temperatureUnit = null;
          self.ebCargo.ebCargoM.airVentsSet = null;
          self.ebCargo.ebCargoM.airVentsUnit = null;
          self.ebCargo.ebCargoM.Humidity = null;
          self.ebCargo.ebCargoM.temperatureMin = null;
          self.ebCargo.ebCargoM.temperatureMax = null;
        }
      }else if (type === "B"){
        if (self.ebCargo.ebCargoM.isBulkyCargo === 0){
          self.ebCargo.ebCargoM.length = null;
          self.ebCargo.ebCargoM.width = null;
          self.ebCargo.ebCargoM.height = null;
          self.ebCargo.ebCargoM.overWeight = null;
          self.ebCargo.ebCargoM.overHigh = null;
          self.ebCargo.ebCargoM.overFront = null;
          self.ebCargo.ebCargoM.overBehind = null;
          self.ebCargo.ebCargoM.overLeft = null;
          self.ebCargo.ebCargoM.overRight = null;
          self.ebCargo.ebCargoM.bulkyCargoRemark = null;
        }
      }
      if (self.ebCargo.ebCargoM.grossWeight) {
        self.ebCargo.ebCargoM.grossWeight = parseFloat(
          self.ebCargo.ebCargoM.grossWeight
        ).toFixed(3);
      }
      if (self.ebCargo.ebCargoM.cube) {
        self.ebCargo.ebCargoM.cube = parseFloat(
          self.ebCargo.ebCargoM.cube
        ).toFixed(3);
      }
      if (self.ebCargo.ebCargoM.netWeight) {
        self.ebCargo.ebCargoM.netWeight = parseFloat(
          self.ebCargo.ebCargoM.netWeight
        ).toFixed(3);
      }

      if (self.ebCargo.ebCargoD.length === 0) {
        let newRow = [
          {
            totalFlag: "D",
            isDeclare: 0,
            isOceanPollution: 0,
            rowStatus: 4,
            // marks: self.ebCargo.ebCargoM.marks,
            cargoName: self.ebCargo.ebCargoM.cargoName,
            noOfPackage: self.ebCargo.ebCargoM.noOfPackage,
            packageTypeName: self.ebCargo.ebCargoM.packageTypeName,
            packageTypeCode: self.ebCargo.ebCargoM.packageTypeCode,
            grossWeight: self.ebCargo.ebCargoM.grossWeight,
            netWeight: self.ebCargo.ebCargoM.netWeight,
            cube: self.ebCargo.ebCargoM.cube,
            isBulkyCargo: self.ebCargo.ebCargoM.isBulkyCargo,
            isReefer: self.ebCargo.ebCargoM.isReefer,
            isHazard: self.ebCargo.ebCargoM.isHazard,
          },
        ];
        self.ebCargo.ebCargoD = newRow.concat(self.ebCargo.ebCargoD);
      } else if (self.ebCargo.ebCargoD.length === 1) {
        let copyCargoD = JSON.parse(JSON.stringify(self.ebCargo.ebCargoD));
        self.ebCargo.ebCargoD[0] = JSON.parse(
          JSON.stringify(self.ebCargo.ebCargoM)
        );
        self.ebCargo.ebCargoD[0].ebCargoId = copyCargoD[0].ebCargoId;
        if (
          self.ebCargo.ebCargoD[0].rowStatus === 2 ||
          self.ebCargo.ebCargoD[0].rowStatus === 16
        ) {
          self.ebCargo.ebCargoD[0].rowStatus = 16;
        } else {
          self.ebCargo.ebCargoD[0].rowStatus = 4;
        }
        (self.ebCargo.ebCargoD[0].totalFlag = "D"),
          self.$refs.ebCargoDRef.loadData(self.ebCargo.ebCargoD);
      } else {
        this.btnVisible = true;
      }
      if (type === "W") {
        self.dangerVisible = !self.dangerVisible;
        self.ebCargo.ebCargoD[0].isHazard = self.ebCargo.ebCargoM.isHazard;
      }
      if (type === "L") {
        self.frezzVisible = !self.frezzVisible;
        self.ebCargo.ebCargoD[0].isReefer = self.ebCargo.ebCargoM.isReefer;
      }
      if (type === "B") {
        self.bigVisible = !self.bigVisible;
        self.ebCargo.ebCargoD[0].isBulkyCargo =
          self.ebCargo.ebCargoM.isBulkyCargo;
      }
      this.$emit("getCargoInfo", this.ebCargo);
    },
    // 货物信息新增
    addNewRow() {
      let self = this;
      let newRow = [
        {
          totalFlag: "D",
          isHazard: 0,
          isReefer: 0,
          isBulkyCargo: 0,
          isDeclare: 0,
          isOceanPollution: 0,
          rowStatus: 4,
        },
      ];
      self.ebCargo.ebCargoD = newRow.concat(self.ebCargo.ebCargoD);
      if (self.ebCargo.ebCargoD.length > 1) {
        this.btnVisible = true;
      }
      // 选中第一条高亮显示
      self.$refs.ebCargoDRef.hotInstance.addHookOnce(
        "afterLoadData",
        function () {
          self.$nextTick(function () {
            self.$refs.ebCargoDRef.hotInstance.selectCell(0, 1);
          });
        }
      );
    },
    // 货物信息删除
    batchDelete() {
      let self = this;
      let delFlag = true;
      let deleteParams = [];
      let params = self.$refs.ebCargoDRef.getSelections();
      // 判断是否选中行都为新增行
      params.forEach((item) => {
        if (item.rowStatus !== 4) {
          deleteParams.push(item);
          delFlag = false;
        }
      });
      // 如果删除行都为新增行则不进行数据库操作
      if (params.length !== 0) {
        self.$coreMethods.confirm(
          function () {
            if (delFlag) {
              // 删除操作
              params.forEach((item) => {
                let index = self.ebCargo.ebCargoD.indexOf(item);
                self.ebCargo.ebCargoD.splice(index, 1);
                item.rowStatus = 8;
              });
              self.ebCargoMCompareEbCargoD();
            } else {
              let ebCargoIds = [];
              deleteParams.forEach((el) => {
                ebCargoIds.push(el.ebCargoId);
              });
              deleteEbCargo({ ebCargoIds: ebCargoIds }).then((res) => {
                if (res.success) {
                  params.forEach((item) => {
                    let index = self.ebCargo.ebCargoD.indexOf(item);
                    self.ebCargo.ebCargoD.splice(index, 1);
                    self.$coreMethods.message("success", "删除成功！");
                  });
                  self.ebCargoMCompareEbCargoD();
                }
              });
            }
            if (self.ebCargo.ebCargoD.length <= 1) {
              self.btnVisible = false;
            }
          },
          function () {},
          false,
          "是否删除勾选数据？"
        );
      } else {
        self.$coreMethods.message("warning", self.$t("请勾选你要删除的数据"));
      }
    },
    // 货物信息单元格点击事件
    ebCargoDCellClick(row) {
      // console.log(this.ebCargo.ebCargoD)
      this.$refs.ebCargoDRef.startEdit(row.physicalRow,row.physicalCol);
      this.ebCargoDIndex = row.physicalRow;
    },
    // 货物信息单元格行点击事件
    ebCargoDRowClick(val) {
      console.log(val);
      this.ebCargoDIndex = val.physicalRow;
    },
    //ebCargoM表和ebCargoD表做比较
    ebCargoMCompareEbCargoD() {
      let self = this;
      let ebCargoLength = self.ebCargo.ebCargoD.length;
      if (ebCargoLength > 0) {
        let newEbCargo = self.ebCargo.ebCargoD.map(
          (item) => item.packageTypeName
        );
        newEbCargo = new Set(newEbCargo);
        if (newEbCargo.size >= 1) {
          self.ebCargo.ebCargoM.packageTypeName = "PACKAGE";
          self.ebCargo.ebCargoM.packageTypeCode = "PACK";
        } else {
          self.ebCargo.ebCargoM.packageTypeName =
            self.ebCargo.ebCargoD[0].packageTypeName;
          self.ebCargo.ebCargoM.packageTypeCode =
            self.ebCargo.ebCargoD[0].packageTypeCode;
        }
        self.ebCargo.ebCargoD.forEach((el, index) => {
          if (index === 0) {
            self.ebCargo.ebCargoM.noOfPackage = 0;
            self.ebCargo.ebCargoM.grossWeight = 0;
            self.ebCargo.ebCargoM.cube = 0;
            self.ebCargo.ebCargoM.netWeight = 0;
          }
          self.ebCargo.ebCargoM.noOfPackage = el.noOfPackage
            ? parseInt(self.ebCargo.ebCargoM.noOfPackage) +
            parseInt(el.noOfPackage)
            : parseInt(self.ebCargo.ebCargoM.noOfPackage);
          self.ebCargo.ebCargoM.grossWeight = el.grossWeight
            ? (
              parseFloat(self.ebCargo.ebCargoM.grossWeight) +
              parseFloat(el.grossWeight)
            ).toFixed(3)
            : parseFloat(self.ebCargo.ebCargoM.grossWeight);
          self.ebCargo.ebCargoM.cube = el.cube
            ? (
              parseFloat(self.ebCargo.ebCargoM.cube) + parseFloat(el.cube)
            ).toFixed(3)
            : parseFloat(self.ebCargo.ebCargoM.cube);
          self.ebCargo.ebCargoM.netWeight = el.netWeight
            ? (
              parseFloat(self.ebCargo.ebCargoM.netWeight) +
              parseFloat(el.netWeight)
            ).toFixed(3)
            : parseFloat(self.ebCargo.ebCargoM.netWeight);
        });
        self.ebCargo.ebCargoM.isBulkyCargo =
          self.ebCargo.ebCargoD[0].isBulkyCargo;
        self.ebCargo.ebCargoM.isReefer = self.ebCargo.ebCargoD[0].isReefer;
        self.ebCargo.ebCargoM.isHazard = self.ebCargo.ebCargoD[0].isHazard;
      } else {
        self.ebCargo.ebCargoM = {}
      }
      this.$emit("getCargoInfo", this.ebCargo);
    },
    // 修改表格后事件
    valueChangeEbCargoD(change, source) {
      let self = this;
      let ebCargoLength = self.ebCargo.ebCargoD.length;
      if (
        (change.prop === "noOfPackage" &&
          self.ebCargo.ebCargoM.noOfPackage === "") ||
        self.ebCargo.ebCargoM.noOfPackage === undefined
      ) {
        self.ebCargo.ebCargoM.noOfPackage = 0;
      }
      if (change.prop === "packageTypeName") {
        if (ebCargoLength > 1) {
          let newEbCargo = self.ebCargo.ebCargoD.map(
            (item) => item.packageTypeName
          );
          newEbCargo = new Set(newEbCargo);
          if (newEbCargo.size !== 1) {
            self.ebCargo.ebCargoM.packageTypeName = "PACKAGE";
            self.ebCargo.ebCargoM.packageTypeCode = "PACK";
          } else {
            self.ebCargo.ebCargoM.packageTypeName =
              self.ebCargo.ebCargoD[0].packageTypeName;
            self.ebCargo.ebCargoM.packageTypeCode =
              self.ebCargo.ebCargoD[0].packageTypeCode;
          }
        }
      }
      if (
        (change.prop === "grossWeight" &&
          self.ebCargo.ebCargoM.grossWeight === "") ||
        self.ebCargo.ebCargoM.grossWeight === undefined
      ) {
        self.ebCargo.ebCargoM.grossWeight = 0;
      }
      if (
        (change.prop === "cube" && self.ebCargo.ebCargoM.cube === "") ||
        self.ebCargo.ebCargoM.cube === undefined
      ) {
        self.ebCargo.ebCargoM.cube = 0;
      }
      if (
        (change.prop === "netWeight" &&
          self.ebCargo.ebCargoM.netWeight === "") ||
        self.ebCargo.ebCargoM.netWeight === undefined
      ) {
        self.ebCargo.ebCargoM.netWeight = 0;
      }
      self.ebCargo.ebCargoD.forEach((el, index) => {
        // 件数
        if (change.prop === "noOfPackage") {
          if (index === 0) {
            self.ebCargo.ebCargoM.noOfPackage = 0;
          }
          self.ebCargo.ebCargoM.noOfPackage = el.noOfPackage
            ? parseInt(self.ebCargo.ebCargoM.noOfPackage) +
            parseInt(el.noOfPackage)
            : parseInt(self.ebCargo.ebCargoM.noOfPackage);
        }
        // 毛重
        if (change.prop === "grossWeight") {
          if (index === 0) {
            self.ebCargo.ebCargoM.grossWeight = 0;
          }
          self.ebCargo.ebCargoM.grossWeight = el.grossWeight
            ? (
              parseFloat(self.ebCargo.ebCargoM.grossWeight) +
              parseFloat(el.grossWeight)
            ).toFixed(3)
            : parseFloat(self.ebCargo.ebCargoM.grossWeight);
        }
        // 体积
        if (change.prop === "cube") {
          if (index === 0) {
            self.ebCargo.ebCargoM.cube = 0;
          }
          self.ebCargo.ebCargoM.cube = el.cube
            ? (
              parseFloat(self.ebCargo.ebCargoM.cube) + parseFloat(el.cube)
            ).toFixed(3)
            : parseFloat(self.ebCargo.ebCargoM.cube);
        }
        // 净重
        if (change.prop === "netWeight") {
          if (index === 0) {
            self.ebCargo.ebCargoM.netWeight = 0;
          }
          self.ebCargo.ebCargoM.netWeight = el.netWeight
            ? (
              parseFloat(self.ebCargo.ebCargoM.netWeight) +
              parseFloat(el.netWeight)
            ).toFixed(3)
            : parseFloat(self.ebCargo.ebCargoM.netWeight);
        }
      });
      //危冷大详情修改
      let isReefers = [];
      let isBulkyCargos = [];
      let isHazards = [];
      self.ebCargo.ebCargoD.forEach(item => {
        isReefers.push(item.isReefer);
        isBulkyCargos.push(item.isBulkyCargo);
        isHazards.push(item.isHazard);
      });
      if (isReefers.indexOf(1) !== -1){
        self.ebCargo.ebCargoM.isReefer = 1;
        self.frezzVisible = true;
      }else {
        self.ebCargo.ebCargoM.isReefer = 0;
        self.frezzVisible = false;
        self.ebCargo.ebCargoM.temperature = null;
        self.ebCargo.ebCargoM.temperatureUnit = null;
        self.ebCargo.ebCargoM.airVentsSet = null;
        self.ebCargo.ebCargoM.airVentsUnit = null;
        self.ebCargo.ebCargoM.Humidity = null;
        self.ebCargo.ebCargoM.temperatureMin = null;
        self.ebCargo.ebCargoM.temperatureMax = null;
      }
      if (isBulkyCargos.indexOf(1) !== -1){
        self.ebCargo.ebCargoM.isBulkyCargo = 1;
        self.bigVisible = true;
      }else {
        self.ebCargo.ebCargoM.isBulkyCargo = 0;
        self.bigVisible = false;
        self.ebCargo.ebCargoM.length = null;
        self.ebCargo.ebCargoM.width = null;
        self.ebCargo.ebCargoM.height = null;
        self.ebCargo.ebCargoM.overWeight = null;
        self.ebCargo.ebCargoM.overHigh = null;
        self.ebCargo.ebCargoM.overFront = null;
        self.ebCargo.ebCargoM.overBehind = null;
        self.ebCargo.ebCargoM.overLeft = null;
        self.ebCargo.ebCargoM.overRight = null;
        self.ebCargo.ebCargoM.bulkyCargoRemark = null;
      }
      if (isHazards.indexOf(1) !== -1){
        self.dangerVisible = true;
        self.ebCargo.ebCargoM.isHazard = 1;
      }else {
        self.dangerVisible = false;
        self.ebCargo.ebCargoM.isHazard = 0;
        self.ebCargo.ebCargoM.unNo = null;
        self.ebCargo.ebCargoM.hazardClass = null;
        self.ebCargo.ebCargoM.flashPoint = null;
        self.ebCargo.ebCargoM.flashPointUnit = null;
        self.ebCargo.ebCargoM.netWeight = null;
        self.ebCargo.ebCargoM.urgentContract = null;
        self.ebCargo.ebCargoM.urgentContractTel = null;
        self.ebCargo.ebCargoM.urgentContractCompany = null;
        self.ebCargo.ebCargoM.dangerTechnicalDesc = null;
        self.ebCargo.ebCargoM.warehouseName = null;
        self.ebCargo.ebCargoM.warehouseAddress = null;
        self.ebCargo.ebCargoM.warehouseContactTel = null;
        self.ebCargo.ebCargoM.warehouseContactFax = null;
        self.ebCargo.ebCargoM.warehouseContact = null;
        self.ebCargo.ebCargoM.isOceanPollution = 0;
        self.ebCargo.ebCargoM.isDeclare = 0;
      }
      self.$forceUpdate();
    },
    //
    afterChangeEbCargoD(change, type) {
      let editRow =
        change !== null ? this.ebCargo.ebCargoD[change[0][0]] : null;
      if (editRow && type === "edit" && editRow.rowStatus === 2) {
        editRow.rowStatus = 16;
      }
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep.is-required .el-form-item__label {
  color: #d9363e !important;
}
.cargoInfo-contanier {
  display: flex;
  flex-direction: column;
}
.position-parent {
  position: relative;
}
.position-title {
  position: absolute;
  top: -7px;
}
.big ::v-deep.el-input-number .el-input__inner {
  text-align: left !important;
}
// .marg10 {
//   margin-top: 10px;
// }
.t-panel {
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
  padding: 10px;
  background-color: #fff;
  box-sizing: border-box;
/*   margin: 0 5px; */
 /*  margin-bottom: 5px; */
}
.goodsSubtotal {
  margin-top: 0px !important;
}
.items-type{
  margin-right: 10px !important;
}
.cargo-type{
.title-panel-external{
   background: rgba(244, 246, 250, 1);
}
}
.add-button{
margin-right:5px
}
</style>
